/**
 * Application-wide constants
 */

// App Info
export const APP_NAME = 'Sunvivo';
export const APP_DESCRIPTION = 'Premium Dental Equipment for Professionals';
export const APP_VERSION = '1.0.0';

// Razorpay
export const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID || '';

// Contact Info
export const SUPPORT_EMAIL = 'support@sunvivo.in';
export const SUPPORT_PHONE = '+91 93238 54481';
export const WHATSAPP_NUMBER = '919323854481';

// Business Rules
export const MAX_CART_ITEMS = 500;
export const MIN_ORDER_VALUE = 500;
export const FREE_SHIPPING_THRESHOLD = 5000;
export const DEFAULT_SHIPPING_COST = 99;
export const GST_RATE = 0.18; // 18% GST

// Pagination
export const DEFAULT_PAGE_SIZE = 12;
export const ADMIN_PAGE_SIZE = 20;

// Image Sizes
export const IMAGE_SIZES = {
  thumbnail: { width: 300, height: 300 },
  product: { width: 800, height: 800 },
  banner: { width: 1920, height: 600 },
} as const;

// Cache Keys (for local storage)
export const STORAGE_KEYS = {
  CART: 'sunvivo_cart',
  WISHLIST: 'sunvivo_wishlist',
  AUTH_TOKEN: 'sunvivo_auth',
  RECENT_SEARCHES: 'sunvivo_recent_searches',
  GUEST_CHECKOUT: 'sunvivo_guest_checkout',
} as const;

// OTP Settings
export const OTP_LENGTH = 6;
export const OTP_RESEND_DELAY = 30; // seconds
export const OTP_MAX_ATTEMPTS = 3;
export const OTP_EXPIRY = 300; // 5 minutes in seconds

// Date Formats
export const DATE_FORMAT = 'dd MMM yyyy';
export const DATETIME_FORMAT = 'dd MMM yyyy, hh:mm a';

// API Limits
export const MAX_SEARCH_RESULTS = 50;
export const DEBOUNCE_DELAY = 300; // ms

// File Upload
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

// Social Links
export const SOCIAL_LINKS = {
  facebook: 'https://facebook.com/sunvivo',
  instagram: 'https://instagram.com/sunvivo',
  twitter: 'https://twitter.com/sunvivo',
  linkedin: 'https://linkedin.com/company/sunvivo',
} as const;
